export default {
  TEN99s: '/agent/taxStatements',
};
